import client from 'search-insights';
import { getRuntimeConfig } from '~/shared/utils/config';
import { trackingStore } from './trackingStore';
import { ALGOLIA_APP_ID, ALGOLIA_TOKEN } from '~/services/instantsearch/variables';

export const useAlgoliaEvents = () => {
    const { config } = getRuntimeConfig();
    const index = config?.NEXT_PUBLIC_ALGOLIA_INDEX;

    function init(userId?: string) {
        if (!index) {
            return;
        }

        client?.('init', {
            appId: ALGOLIA_APP_ID,
            apiKey: ALGOLIA_TOKEN,
            userToken: userId,
        });
        const { setIsTracking, setUserToken } = trackingStore.getState();
        setIsTracking(true);
        setUserToken(userId);
    }

    function onUserChange(userId: string) {
        const { isTracking, setUserToken } = trackingStore.getState();
        if (!isTracking) return;
        client?.('setUserToken', userId);
        setUserToken(userId);
    }

    // Click, conversion and view events are sent to Algolia by GTM; only the user token is kept here
    return {
        aiOnInit: init,
        aiOnUserChange: onUserChange,
    };
};
